import React from "react";
import { FieldError, UseFormRegisterReturn } from "react-hook-form";
import { FormRow } from "./FormRow";

interface TextareaProps {
  label: string;
  registration?: UseFormRegisterReturn;
  required?: boolean;
  error?: FieldError;
  placeholder?: string;
  rows?: number;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

export const Textarea: React.FC<TextareaProps> = ({
  label,
  registration,
  required = false,
  error,
  placeholder = "",
  rows = 3,
  value,
  onChange,
}) => {
  const textareaProps = registration
    ? { ...registration }
    : {
        value,
        onChange
      };

  return (
    <FormRow label={label} required={required} error={error} className="commentRow">
      <textarea rows={rows} placeholder={placeholder} {...textareaProps} />
    </FormRow>
  );
};